import http from "@/shared/axios-config/g-http-metodos";

function GetCondicoesPagamentoByFiltro(formaPagamentoViewModel) {
    const { res, erro, requisicao } = http.postArray(`FormaPagamento/GetCondicoesPagamentoByFiltro`, formaPagamentoViewModel)
    return { FormasPagArray: res, erro, requisicao }
}
function GetCondicoesPagamento() {
    const { res, erro, requisicao } = http.postArray(`FormaPagamento/GetCondicoesPagamento`)
    return { FormasPagArray: res, erro, requisicao }
}


function InativaFormaPagamento(formaPagamentoId, ativo) {
    const { res, erro, requisicao } = http.post(`FormaPagamento/InativaFormaPagamento/${formaPagamentoId}/${ativo}`)
    return { res, erro, requisicao }
}

const CondicoesPagamentoController = {
    GetCondicoesPagamentoByFiltro,
    GetCondicoesPagamento,
    InativaFormaPagamento
}

export default CondicoesPagamentoController;